export default __webpack_public_path__ + "static/media/settings-off.1e053a8a.svg";